import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-[1.6rem]" }
const _hoisted_2 = { class: "flex flex-wrap md:flex-nowrap items-center justify-center gap-[1.6rem]" }
const _hoisted_3 = { class: "flex flex-wrap md:flex-nowrap items-center justify-center gap-[1.6rem]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OnlineButton = _resolveComponent("OnlineButton")!
  const _component_InPersonButton = _resolveComponent("InPersonButton")!
  const _component_LocationAutocomplete = _resolveComponent("LocationAutocomplete")!
  const _component_CalendarButton = _resolveComponent("CalendarButton")!
  const _component_TherapyFilter = _resolveComponent("TherapyFilter")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_OnlineButton, {
        modelValue: _ctx.online,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.online) = $event)),
        class: "shrink-0 md:flex-none md:min-w-[9.5rem]"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_InPersonButton, {
        modelValue: _ctx.inPerson,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inPerson) = $event)),
        class: "shrink-0 md:flex-none md:min-w-[9.5rem]"
      }, null, 8, ["modelValue"]),
      (_ctx.inPerson)
        ? (_openBlock(), _createBlock(_component_LocationAutocomplete, {
            key: 0,
            modelValue: _ctx.location,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.location) = $event)),
            placeholder: _ctx.$t('Address, city, country') + '...',
            class: "w-full md:flex-none md:min-w-[16rem] md:max-w-[26rem]"
          }, null, 8, ["modelValue", "placeholder"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_CalendarButton, {
        modelValue: _ctx.dateFrom,
        "onUpdate:modelValue": [
          _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dateFrom) = $event)),
          _cache[4] || (_cache[4] = (value) => { _ctx.dateFrom = value; })
        ],
        class: "w-full md:flex-none md:min-w-[22rem] md:max-w-[34rem]"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_TherapyFilter, {
        modelValue: _ctx.therapyObj,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.therapyObj) = $event)),
        class: "w-full md:flex-none md:min-w-[18rem] md:max-w-[26rem] sm:mr-[6px]"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_AppButton, {
        class: "w-full sm:mt-4 md:w-auto md:min-w-[11rem] md:mt-0 md:flex-none",
        variant: "brand",
        label: _ctx.$t('Search'),
        loading: _ctx.searchLoading,
        disabled: _ctx.searchLoading,
        onClick: _withModifiers(_ctx.emitSearch, ["prevent"])
      }, null, 8, ["label", "loading", "disabled", "onClick"])
    ])
  ]))
}